import gql from 'graphql-tag';

const SEO_SEARCH_QUERY = gql`
  query SeoSearch(
    $cityId: String!
    $filters: FiltersInput
    $locale: String
    $limit: Int
  ) {
    search(cityId: $cityId, filters: $filters, limit: $limit, locale: $locale) {
      totalMarkers
      markersMinimumPrice
      markersMaximumPrice
      markers {
        id
        coord
        instantBooking
        minimumPrice
        so
        totalCountMultilisting
      }
      homecards(locale: $locale) {
        checked
        currencyIsoCode
        firstAvailableDate
        id
        city
        isInstantBooking
        noSecurityDeposit
        hasDepositProtection
        isFavorite
        mainPhotoUrl
        reviews {
          ratingAverage
        }
        title
        description
        type
        url
        features
        area
        roomArea
        offers {
          discountType
          discountValue
        }
        allowsPermanentContract
        responseRateState
        numberOfBathrooms
        numberOfBedrooms
        isBestChoice
        location
        landlordId
        so
        photoIds
        otherPropertyPhotoIds
        displayPrice
        billsIncluded
        totalCountMultilisting
        landlordScoring {
          score
          totalBookingsClosed
        }
      }
    }
    geocodeLocation(locationString: $cityId) {
      lat
      lng
    }
  }
`;

export const requestSeoSearchData =
  client =>
  ({ cityId, filters, locale, limit }) =>
    client.query({
      query: SEO_SEARCH_QUERY,
      variables: { cityId, filters, locale, limit },
      fetchPolicy: 'network-only'
    });

export default SEO_SEARCH_QUERY;
